export default "/public/dist/img/logo_2403.png";